export default "__VITE_ASSET__40e98b57__"